var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g2, _path51, _g3, _path52, _g4, _path53, _g5, _path54, _g6, _path55, _g7, _path56, _g8, _path57, _g9, _path58, _g10, _path59, _g11, _path60, _g12, _path61, _g13, _path62, _g14, _path63, _g15, _path64, _g16, _path65, _g17, _path66, _g18, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g19, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinInterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 241,
    viewBox: "0 0 300 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.039 233.567H274.992V240.867H160.039V233.567Z",
    fill: "url(#paint0_linear_4_15439)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.472 49.7373L193.184 21.5409V12.2563C193.184 9.98492 195.025 8.14362 197.297 8.14362H227.828C230.099 8.14362 231.941 9.98492 231.941 12.2563V78.7516C231.941 81.0228 230.099 82.8643 227.828 82.8643H197.297C195.025 82.8643 193.184 81.0228 193.184 78.7516V28.6452L159.472 49.7373Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.102 0.518005H239.579V23.995H216.102V0.518005Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.841 31.1626H197.997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.269 39.2494H206.437",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.841 39.2494H211.08",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211.561 23.0758H202.01",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.561 14.9889H197.997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.841 47.3363H197.997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.841 55.4231H203.024",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200.4 63.51H197.997",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.841 63.51H203.65",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.155 74.3452C223.672 74.3452 222.47 73.1428 222.47 71.6596C222.47 70.1764 223.672 68.974 225.155 68.974C226.638 68.974 227.841 70.1764 227.841 71.6596C227.841 73.1428 226.638 74.3452 225.155 74.3452Z",
    fill: "#1F97FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.745 74.3452C214.262 74.3452 213.06 73.1428 213.06 71.6596C213.06 70.1764 214.262 68.974 215.745 68.974C217.229 68.974 218.431 70.1764 218.431 71.6596C218.431 73.1428 217.229 74.3452 215.745 74.3452Z",
    fill: "#FF8D69"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.149 19.5644L220.533 4.9487",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M235.149 4.9487L220.533 19.5644",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M216.102 0.518005H239.579V23.995H216.102V0.518005Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.879 110.23C111.458 86.0893 131.705 68.8144 155.498 68.8144C173.04 68.8144 188.643 78.2149 198.676 92.8226C200.783 95.8904 202.641 99.1856 204.222 102.675C208.104 111.244 210.309 120.96 210.309 131.267C210.309 148.614 204.1 164.306 194.08 175.623C174.437 173.488 155.356 166.14 139.455 154.399C124.078 143.046 111.749 127.642 103.879 110.23Z",
    fill: "#A1D5F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34665 26.2334H84.648C86.9194 26.2334 88.7607 28.0747 88.7607 30.3461V82.5841C88.7607 84.8555 86.9194 86.6968 84.648 86.6968H46.9448L67.1078 120.709L39.777 86.6968H4.34665C2.07525 86.6968 0.233948 84.8555 0.233948 82.5841V30.3461C0.233948 28.0747 2.07525 26.2334 4.34665 26.2334Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1011 44.5477V46.2403C19.1011 49.7468 21.9437 52.5893 25.4501 52.5893C28.9566 52.5893 31.7991 55.4319 31.7991 58.9383V60.3488C31.7991 63.8553 34.6417 66.6978 38.1481 66.6978C41.6546 66.6978 44.4971 63.8553 44.4971 60.3488V39.0149C44.4971 35.5084 47.3397 32.6659 50.8461 32.6659C54.3526 32.6659 57.1951 35.5085 57.1951 39.0149V56.0913C57.1951 59.5978 60.0376 62.4403 63.5441 62.4403C67.0506 62.4403 69.8931 59.5977 69.8931 56.0913V54.985C69.8931 51.4785 72.7357 48.636 76.2421 48.636C79.7486 48.636 82.5911 51.4786 82.5911 54.985V80.528H69.893H57.1949H44.4968H31.7987H19.1006H6.40247V44.5478C6.40247 41.0413 9.24506 38.1988 12.7515 38.1988C16.2586 38.1987 19.1011 41.0412 19.1011 44.5477Z",
    fill: "#FF8D69"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2424 32.4025V80.5279",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6802 32.4025V80.5279",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1182 32.4025V80.5279",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5562 32.4025V80.5279",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9939 32.4025V80.5279",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4319 32.4025V80.5279",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2423 50.4087C75.4023 50.4087 74.7212 49.7277 74.7212 48.8876C74.7212 48.0475 75.4023 47.3665 76.2423 47.3665C77.0824 47.3665 77.7634 48.0475 77.7634 48.8876C77.7634 49.7277 77.0824 50.4087 76.2423 50.4087Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6803 63.9456C62.8402 63.9456 62.1592 63.2646 62.1592 62.4245C62.1592 61.5844 62.8402 60.9034 63.6803 60.9034C64.5204 60.9034 65.2014 61.5844 65.2014 62.4245C65.2014 63.2646 64.5204 63.9456 63.6803 63.9456Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1181 34.4712C50.278 34.4712 49.597 33.7902 49.597 32.9501C49.597 32.11 50.278 31.429 51.1181 31.429C51.9582 31.429 52.6392 32.11 52.6392 32.9501C52.6392 33.7902 51.9582 34.4712 51.1181 34.4712Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5561 68.2297C37.716 68.2297 37.035 67.5487 37.035 66.7086C37.035 65.8685 37.716 65.1875 38.5561 65.1875C39.3961 65.1875 40.0771 65.8685 40.0771 66.7086C40.0771 67.5487 39.3961 68.2297 38.5561 68.2297Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.994 54.1779C25.1539 54.1779 24.4729 53.4969 24.4729 52.6568C24.4729 51.8167 25.1539 51.1357 25.994 51.1357C26.8341 51.1357 27.5151 51.8167 27.5151 52.6568C27.5151 53.4969 26.8341 54.1779 25.994 54.1779Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4318 39.6482C12.5917 39.6482 11.9107 38.9672 11.9107 38.1271C11.9107 37.287 12.5917 36.606 13.4318 36.606C14.2718 36.606 14.9529 37.287 14.9529 38.1271C14.9529 38.9672 14.2718 39.6482 13.4318 39.6482Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.276 207.271L75.757 222.823V189.613C75.757 187.342 73.9157 185.5 71.6443 185.5H24.5028C22.2314 185.5 20.3901 187.342 20.3901 189.613V236.755C20.3901 239.026 22.2314 240.867 24.5028 240.867H71.6443C73.9157 240.867 75.757 239.026 75.757 236.755V229.822L102.276 207.271Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2046 189.38H71.877V196.025",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2701 196.025V189.38H30.9138",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9424 236.987H24.27V230.343",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.877 230.343V236.987H65.2332",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7017 230.505C42.9663 230.459 36.7427 222.559 36.8009 212.86C36.8591 203.162 43.1771 195.337 50.9125 195.383C58.6479 195.43 64.8715 203.33 64.8133 213.028C64.7551 222.727 58.4372 230.552 50.7017 230.505Z",
    fill: "#FF8D69"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6499 216.973C61.2475 223.767 56.4216 228.777 50.7313 228.743C49.8996 228.738 49.0698 228.624 48.2644 228.405C42.6144 226.864 38.546 220.335 38.5904 212.881C38.6157 208.59 39.9593 204.58 42.3737 201.59C43.761 199.871 45.4044 198.618 47.184 197.893",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8196 212.87C36.8773 203.172 43.1948 195.347 50.9302 195.393L45.444 195.36C37.7088 195.314 31.3914 203.139 31.3336 212.837C31.2759 222.536 37.4997 230.435 45.2349 230.481L50.7211 230.514C42.9857 230.468 36.7618 222.569 36.8196 212.87Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 195,
    width: 20,
    height: 36
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8196 212.87C36.8773 203.172 43.1948 195.347 50.9302 195.393L45.444 195.36C37.7088 195.314 31.3914 203.139 31.3336 212.837C31.2759 222.536 37.4997 230.435 45.2349 230.481L50.7211 230.514C42.9857 230.468 36.7618 222.569 36.8196 212.87Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57349 198.659L89.7588 199.154",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55258 202.188L89.7378 202.684",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53159 205.718L89.7168 206.213",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5105 209.247L89.6958 209.743",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48953 212.777L89.6748 213.272",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46851 216.307L89.6538 216.802",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44751 219.836L89.6328 220.332",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42636 223.366L89.6116 223.861",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40536 226.896L89.5906 227.391",
    stroke: "#FF8D69",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2087 205.937H49.052C46.9676 205.937 45.5106 207.121 45.5106 209.372C45.5106 211.002 46.8754 212.555 48.4248 212.516V212.555C46.7092 212.632 45.1046 213.603 45.1046 216.029C45.1046 217.639 46.0822 219.794 49.5314 219.794H56.2086L56.2087 205.937Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48.425 212.516H56.2087",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3088 202.32V205.937",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3088 219.794V223.411",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3691 202.32V205.937",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3691 219.794V223.411",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H130.763C97.0851 62.6454 69.7839 93.3685 69.7839 131.267C69.7839 169.166 97.0851 199.89 130.763 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "#1F97FC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1961 135.772H78.6445C87.3 135.772 94.7279 141.727 96.8533 150.118C102.683 173.132 118.92 191.207 139.475 197.49H132.592H130.763C99.801 197.49 74.3767 170.194 72.3211 135.772H78.1961Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 126.078H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 135.772H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 145.466H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 155.159H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 164.853H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 174.547H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 184.241H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 193.934H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 67.9156H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 77.6094H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 87.3031H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 96.9968H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 106.691H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 116.384H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 126.078H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 135.772H441.067",
    stroke: "#1F97FC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 62,
    width: 84,
    height: 138
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5185 131.267C94.5185 93.3685 121.82 62.6454 155.498 62.6454H134.19C100.512 62.6454 72.3212 93.3685 72.3212 131.267C72.3212 171.936 103.77 199.89 138.189 199.89H155.494C121.818 199.887 94.5185 169.165 94.5185 131.267Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-249.21 135.772H441.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M196.048 167.858L184.449 156.259V115.213",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M190.249 86.9617L155.57 121.64V145.461",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M184.449 164.292V181.273",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M170.117 120.226V176.63",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M170.117 71.9644V90.1442",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M198.782 98.917V152.341",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M155.784 68.8145V105.28",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M155.784 156.454V193.72",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M141.452 70.8965V191.557",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M127.12 166.631V148.004L101.284 122.168",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M127.12 96.0796V138.632",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M112.787 92.1715V112.332",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M112.787 145.461V170.155",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M170.117 96.0796C168.478 96.0796 167.149 94.7509 167.149 93.1119C167.149 91.4729 168.478 90.1442 170.117 90.1442C171.756 90.1442 173.085 91.4729 173.085 93.1119C173.085 94.7509 171.756 96.0796 170.117 96.0796Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M155.784 111.215C154.145 111.215 152.817 109.887 152.817 108.248C152.817 106.609 154.145 105.28 155.784 105.28C157.424 105.28 158.752 106.609 158.752 108.248C158.752 109.887 157.424 111.215 155.784 111.215Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M127.119 96.0796C125.48 96.0796 124.152 94.7509 124.152 93.1119C124.152 91.4729 125.48 90.1442 127.119 90.1442C128.758 90.1442 130.087 91.4729 130.087 93.1119C130.087 94.7509 128.758 96.0796 127.119 96.0796Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M155.498 151.397C153.859 151.397 152.53 150.068 152.53 148.429C152.53 146.79 153.859 145.461 155.498 145.461C157.137 145.461 158.465 146.79 158.465 148.429C158.465 150.068 157.137 151.397 155.498 151.397Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M170.117 182.566C168.478 182.566 167.149 181.237 167.149 179.598C167.149 177.959 168.478 176.63 170.117 176.63C171.756 176.63 173.085 177.959 173.085 179.598C173.085 181.237 171.756 182.566 170.117 182.566Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M184.45 115.213C182.811 115.213 181.482 113.884 181.482 112.245C181.482 110.606 182.811 109.277 184.45 109.277C186.089 109.277 187.417 110.606 187.417 112.245C187.417 113.884 186.089 115.213 184.45 115.213Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M127.119 173.429C125.48 173.429 124.152 172.1 124.152 170.461C124.152 168.822 125.48 167.493 127.119 167.493C128.758 167.493 130.087 168.822 130.087 170.461C130.087 172.1 128.758 173.429 127.119 173.429Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M112.787 118.181C111.148 118.181 109.819 116.852 109.819 115.213C109.819 113.574 111.148 112.245 112.787 112.245C114.426 112.245 115.755 113.574 115.755 115.213C115.755 116.852 114.426 118.181 112.787 118.181Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M209.706 99.8507C207.947 96.0165 205.88 92.3958 203.536 89.0249C192.374 72.9743 175.014 62.6451 155.498 62.6451C121.82 62.6451 94.5191 93.3685 94.5191 131.268C94.5191 169.167 121.82 199.889 155.498 199.889C189.176 199.889 216.478 169.167 216.478 131.268C216.478 119.941 214.025 109.266 209.706 99.8507ZM210.308 131.268C210.308 165.759 185.769 193.72 155.498 193.72C125.227 193.72 100.688 165.759 100.688 131.268C100.688 96.7757 125.227 68.8144 155.498 68.8144C173.04 68.8144 188.643 78.215 198.676 92.8226C200.783 95.8904 202.641 99.1857 204.222 102.675C208.104 111.244 210.308 120.96 210.308 131.268Z",
    fill: "#A1D5F9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M139.455 154.399C155.356 166.14 174.437 173.488 194.079 175.623C184.175 186.809 170.545 193.72 155.497 193.72C125.227 193.72 100.688 165.759 100.688 131.267C100.688 123.885 101.815 116.804 103.879 110.23C111.749 127.642 124.078 143.046 139.455 154.399Z",
    fill: "#1F97FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_4_15439",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 110,
    width: 95,
    height: 84
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.455 154.399C155.356 166.14 174.437 173.488 194.079 175.623C184.175 186.809 170.545 193.72 155.497 193.72C125.227 193.72 100.688 165.759 100.688 131.267C100.688 123.885 101.815 116.804 103.879 110.23C111.749 127.642 124.078 143.046 139.455 154.399Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_4_15439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.449 170.461V181.273",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.117 117.484V176.63",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.784 159.195V193.72",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.452 70.8965V191.557",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.119 167.493V148.004L101.283 122.168",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.787 142.719V170.155",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.117 182.566C168.478 182.566 167.149 181.237 167.149 179.598C167.149 177.959 168.478 176.63 170.117 176.63C171.756 176.63 173.084 177.959 173.084 179.598C173.084 181.237 171.756 182.566 170.117 182.566Z",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.119 173.429C125.48 173.429 124.152 172.1 124.152 170.461C124.152 168.822 125.48 167.493 127.119 167.493C128.758 167.493 130.087 168.822 130.087 170.461C130.087 172.1 128.758 173.429 127.119 173.429Z",
    stroke: "#A1D5F9",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M206.467 131.267C206.467 121.111 204.378 111.406 200.257 102.423C198.663 98.9461 196.769 95.6233 194.63 92.5475C184.543 78.0424 169.669 69.4907 153.583 68.8568C154.219 68.8317 154.856 68.8145 155.498 68.8145C172.319 68.8145 187.982 77.465 198.471 92.5475C200.61 95.6233 202.504 98.9462 204.098 102.423C208.219 111.406 210.309 121.111 210.309 131.267C210.309 165.704 185.72 193.72 155.498 193.72C154.855 193.72 154.215 193.703 153.577 193.678C182.914 192.521 206.467 164.971 206.467 131.267Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M254.884 125.297C254.988 125.184 258.99 119.902 258.99 119.902L256.276 113.582L250.38 115.024L254.884 125.297Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M279.261 102.075L278.019 101.552L278.553 94.7769L267.7 96.1658L267.266 101.687L265.336 102.721L269.657 111.463L279.261 102.075Z",
    fill: "#F6A68D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M279.261 102.075L269.657 111.463L265.336 102.721L257.932 106.688C254.497 108.528 254.983 111.738 255.829 115.541L258.502 138.507L286.054 137.218L294.616 113.726C295.535 111.206 294.314 108.409 291.843 107.369L288.305 105.88L279.261 102.075Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M274.187 99.2592C272.993 99.6554 271.39 100.021 269.679 100.08C266.546 100.188 263.795 99.0348 262.065 96.8438C261.44 93.5429 261.316 90.0727 262.493 86.9072C264.174 82.7214 268.134 79.9594 272.799 80.638C275.427 81.0202 277.833 82.4432 279.434 84.5615C281.147 86.8282 281.221 90.1492 280.258 92.7465C279.727 94.1774 278.898 95.4553 277.724 96.5033L274.187 99.2592Z",
    fill: "#F6A68D"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M273.021 88.31C273.705 88.6333 274.102 89.3113 274.109 90.0205L271.009 88.5563C271.561 88.1112 272.337 87.9868 273.021 88.31Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M264.23 87.1869C264.809 87.0787 265.387 87.4222 265.741 88.0055L263.117 88.4957C263.236 87.8241 263.651 87.2952 264.23 87.1869Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M271.341 92.5874C271.664 92.5874 271.944 92.3459 271.984 92.0171L272.068 91.3206C272.112 90.9651 271.859 90.6421 271.503 90.5987C271.148 90.5575 270.825 90.8081 270.781 91.1641L270.696 91.8606C270.653 92.2161 270.906 92.5391 271.262 92.5825C271.288 92.5856 271.315 92.5874 271.341 92.5874Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M264.629 91.7783C264.952 91.7783 265.231 91.5368 265.271 91.2079L265.356 90.5109C265.399 90.1554 265.146 89.8324 264.791 89.789C264.436 89.7501 264.112 89.9993 264.069 90.3544L263.984 91.0514C263.941 91.4069 264.194 91.7299 264.549 91.7733C264.576 91.7765 264.602 91.7783 264.629 91.7783Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M267.789 95.1943C268.457 95.3823 269.232 94.88 269.333 94.1936",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M267.318 91.3791C267.262 91.9151 267.006 92.5878 266.775 92.9293",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M266.967 99.8402C267.824 100.031 268.734 100.113 269.679 100.08C271.39 100.021 272.993 99.6554 274.187 99.2592",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M278.453 95.6848C277.516 95.6848 276.757 94.9255 276.757 93.9888C276.757 93.0521 277.516 92.2928 278.453 92.2928C279.39 92.2928 280.149 93.0521 280.149 93.9888C280.149 94.9255 279.39 95.6848 278.453 95.6848Z",
    fill: "#F6A68D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 103.086L274.917 114.93L269.657 111.463L265.336 114.93L262.795 104.082",
    stroke: "#1F97FC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M281.265 83.0896C277.404 80.7987 271.009 77.0002 269.165 75.9172C267.748 75.085 265.741 75.1411 264.086 76.1612C262.332 77.2427 261.586 79.7 262.446 81.5724C261.962 81.1213 261.227 80.9584 260.598 81.1624C259.968 81.3665 259.469 81.9292 259.341 82.5786C259.182 83.3855 259.563 84.1901 259.932 84.9245C260.577 86.2059 261.287 87.5793 261.932 88.8607C262.287 86.7331 263.325 85.0606 264.357 83.828C264.681 85.1898 265.616 86.0022 267.004 86.1171C269.121 86.2923 271.009 85.8348 273.347 85.9922C274.315 86.0573 275.954 86.2546 277.426 87.0579C276.86 88.8149 277.232 90.8313 278.335 92.3039C278.416 92.2983 278.496 92.2914 278.578 92.2975C279.512 92.3668 280.214 93.1802 280.144 94.1143C280.079 94.9925 279.355 95.6561 278.493 95.6758L278.28 98.3643C280.94 96.2992 283.151 92.8214 283.653 89.2404C283.976 86.9343 283.728 84.5508 281.265 83.0896Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M298.688 137.156L296.541 112.685L289.282 124.441L291.438 138.066L292.445 157.115H296.256C298.584 148.913 301.184 144.735 298.688 137.156Z",
    fill: "#F6A68D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M287.901 130.71L299.76 126.203L297.15 113.557C296.591 110.846 294.732 108.585 292.181 107.512L285.166 104.56L287.901 130.71Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M296.016 165.496C295.515 165.947 294.405 166.711 294.405 166.711L294.131 166.051C294.131 166.051 295.094 165.033 295.538 164.507C295.709 164.845 295.845 165.158 296.016 165.496Z",
    fill: "#D57767"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M296.99 166.053C296.513 167.022 295.133 168.694 295.133 168.694L294.389 168.169C294.389 168.169 295.51 166.333 296.105 165.446C295.967 164.107 295.481 162.725 295.536 161.38C295.537 161.342 296.161 161.538 296.212 161.557C296.632 161.717 297.173 161.77 297.619 161.805C297.53 162.526 297.467 163.238 297.427 163.967C297.389 164.679 297.309 165.405 296.99 166.053Z",
    fill: "#D57767"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M298.88 163.95L297.143 170.391L296.163 170.082C296.163 170.082 296.856 166.557 296.877 166.249C296.979 164.766 296.757 163.283 296.82 161.798C296.809 162.047 297.773 162.663 297.967 162.829L298.88 163.95Z",
    fill: "#D57767"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M295.602 155.99L292.474 157.006C291.495 159.306 292.734 161.32 293.49 162.714L295.146 166.214L296.315 165.638L295.543 161.947L296.277 161.684C296.277 161.684 296.87 162.55 297.337 163.625C297.643 164.649 298.059 165.869 298.234 166.603C298.276 166.977 298.011 168.903 298.141 169.757L299.027 170.038L299.632 166.886L299.163 162.866C299.163 162.866 296.187 157.135 295.602 155.99Z",
    fill: "#F6A68D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M276.778 223.071L279.037 226.82V231.859H275.817L272.792 229.468L270.459 226.173L276.778 223.071Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M260.146 230.061L259.276 233.229L262.105 236.795L265.709 236.601L266.374 232.608L267.725 230.061L267.26 229.005L260.146 230.061Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M258.502 138.507C257.549 140.787 256.851 143.649 253.401 155.002C251.13 162.478 247.707 174.693 245.938 182.221C244.963 186.371 245.751 190.733 248.116 194.28L262.667 216.108C263.742 208.644 264.449 201.74 265.068 193.363C264.533 191.714 261.96 188.756 260.076 187.069L266.209 174.072L266.257 174.095C265.188 194.945 263.716 214.25 260.146 230.061H267.725C284.915 206.705 275.317 203.815 282.323 179.239C290.863 149.281 287.419 149.898 286.054 137.218L258.502 138.507Z",
    fill: "#1F97FC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M269.913 226.977L270.209 227.42L276.778 223.071C276.359 221.058 275.944 219.177 275.529 217.408C274.231 220.2 272.421 223.328 269.913 226.977Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M274.427 140.493L286.29 139.938",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M257.493 141.285L262.161 141.067",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M267.372 148.388C267.644 145.609 267.917 142.831 268.189 140.052C266.635 141.972 265.447 143.826 264.311 146.02",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M268.372 140.119C269.408 140.663 270.567 140.969 271.736 141.008C272.105 141.021 272.491 141.002 272.811 140.818C273.13 140.634 273.355 140.239 273.233 139.891C273.088 139.474 272.57 139.342 272.13 139.313C270.406 139.201 268.858 139.961 267.318 140.623C266.592 140.934 265.731 141.368 264.931 141.424C264.371 141.463 263.467 141.14 263.745 140.41C263.897 140.01 264.278 139.73 264.687 139.604C265.096 139.478 265.533 139.486 265.96 139.521C266.869 139.594 267.769 139.78 268.632 140.072",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M262.667 216.108C263.742 208.644 264.448 201.74 265.067 193.363L266.257 174.095C266.518 169.015 266.754 163.843 266.992 158.607",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M250.072 240.867H266.992C266.992 240.867 266.992 236.827 266.992 235.559C266.992 234.292 266.313 232.433 266.313 232.433C265.515 232.763 264.594 233.379 264.321 234.198C264.21 234.529 264.156 234.881 263.997 235.191C263.837 235.501 263.532 235.772 263.184 235.753C262.798 235.732 262.516 235.368 262.387 235.003C262.109 234.215 262.281 233.294 261.875 232.563C261.554 231.985 260.916 231.636 260.267 231.508C259.618 231.379 258.948 231.44 258.289 231.502C257.459 233.709 256.312 235.859 254.249 237.002C253.366 237.492 252.408 237.849 251.563 238.403C250.718 238.957 250.237 239.871 250.072 240.867Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M268.261 240.867H273.358C275.357 240.867 277.23 239.889 278.371 238.248L283.267 231.209C283.657 230.647 283.578 229.883 283.079 229.414L278.779 225.366C278.162 225.575 277.829 226.284 278.021 226.906C278.214 227.528 278.607 228.101 278.63 228.752C278.658 229.582 277.996 230.364 277.181 230.522C275.68 230.814 274.306 229.253 272.792 229.468C272.8 231.191 272.679 231.063 272.687 232.786C272.695 234.244 270.733 237.02 268.658 238.331C268.041 238.721 268.027 240.176 268.261 240.867Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M263.017 180.836L266.717 163.31L266.257 174.095L263.017 180.836Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M287.555 127.199L288.252 130.495",
    stroke: "#1F97FC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M236.381 111.835C238.044 118.048 239.472 122.269 243.559 127.904C245.668 130.81 250.037 130.712 252.017 127.717L258.922 117.267C259.831 115.892 260.025 114.164 259.445 112.621L257.334 107.006L254.884 108.336C252.998 109.361 251.431 110.887 250.357 112.747L247.062 118.455L238.93 107.512L236.381 111.835Z",
    fill: "#F6A68D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M231.207 115.625L231.296 115.536C231.511 115.321 231.511 114.973 231.296 114.758L229.491 112.952C229.276 112.737 228.928 112.737 228.713 112.952L228.623 113.042C227.91 113.755 227.91 114.912 228.623 115.625C229.337 116.338 230.493 116.338 231.207 115.625Z",
    fill: "#FF8D69"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M241.506 106.064L233.216 114.354L233.215 114.355L232.386 115.184L232.384 115.185L232.365 115.205C232.306 115.264 232.237 115.305 232.163 115.332C231.611 115.568 230.668 115.2 229.861 114.393L229.858 114.39L239.845 104.403L241.506 106.064Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M228.89 112.178C228.909 112.07 228.96 111.967 229.044 111.883L238.184 102.742L239.845 104.403L229.859 114.39C229.094 113.624 228.725 112.738 228.89 112.178Z",
    fill: "#082AC8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M241.855 104.377C242.19 104.712 242.19 105.257 241.855 105.592C241.843 105.603 241.461 105.978 241.445 105.978C241.429 105.978 241.415 105.973 241.404 105.961L239.829 104.387L240.839 103.362L241.855 104.377Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M242.224 105.961C242.763 105.422 242.763 104.548 242.224 104.008L240.24 102.025C239.701 101.486 238.826 101.486 238.287 102.025C238.061 102.251 238.061 102.618 238.287 102.845L241.403 105.961C241.63 106.188 241.997 106.188 242.224 105.961Z",
    fill: "#FF8D69"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M239.427 104.787C238.322 103.682 237.895 102.319 238.472 101.742C239.049 101.165 240.412 101.592 241.517 102.697C242.621 103.801 243.049 105.164 242.471 105.742C241.894 106.319 240.531 105.891 239.427 104.787Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M237.47 102.742L238.47 101.742C237.884 102.328 238.303 103.666 239.425 104.787C240.546 105.908 241.884 106.328 242.469 105.742L241.47 106.741C240.884 107.327 239.546 106.908 238.425 105.786C237.304 104.665 236.884 103.328 237.47 102.742Z",
    fill: "#FF8D69"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M259.481 94.5413C259.481 89.1385 255.101 84.7586 249.698 84.7586H251.791C257.194 84.7586 261.573 89.1385 261.573 94.5413C261.573 99.9441 257.194 104.324 251.791 104.324H249.698C255.101 104.324 259.481 99.9441 259.481 94.5413Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M250.585 103.192C245.808 103.192 241.934 99.3192 241.934 94.5413C241.934 89.7634 245.808 85.8902 250.585 85.8902C255.363 85.8902 259.237 89.7634 259.237 94.5413C259.237 99.3192 255.363 103.192 250.585 103.192Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M253.045 87.8342C253.055 87.8237 253.066 87.8135 253.077 87.8037C253.34 87.5786 253.902 87.6136 254.195 87.719C254.868 87.9612 255.418 88.6121 255.56 89.3135C255.69 89.9559 255.052 90.2615 254.597 89.7915C254.206 89.3885 253.766 89.0334 253.287 88.736C253.02 88.5702 252.798 88.0968 253.045 87.8342Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M244.745 91.5579C245.184 93.1787 245.934 94.7158 246.955 96.0495C248.376 97.9054 250.312 99.3594 252.485 100.219C251.662 100.643 250.73 100.884 249.742 100.884C246.432 100.884 243.738 98.191 243.738 94.8804C243.738 93.6526 244.11 92.5101 244.745 91.5579Z",
    fill: "#A1D5F9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M239.919 102.645L240.964 101.601C240.958 101.607 240.953 101.614 240.948 101.62L241.997 100.571C240.694 98.9089 239.915 96.8168 239.915 94.5414C239.915 89.1386 244.295 84.7587 249.698 84.7587C255.101 84.7587 259.481 89.1386 259.481 94.5414C259.481 99.9442 255.101 104.324 249.698 104.324C247.423 104.324 245.33 103.545 243.669 102.242L241.695 104.216L241.69 104.21L241.587 104.313C241.343 104.558 240.785 104.383 240.318 103.915C239.85 103.447 239.675 102.89 239.919 102.645ZM249.698 102.401C254.039 102.401 257.558 98.882 257.558 94.5413C257.558 90.2006 254.039 86.6818 249.698 86.6818C245.357 86.6818 241.838 90.2006 241.838 94.5413C241.838 98.882 245.357 102.401 249.698 102.401Z",
    fill: "#FF8D69"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M249.698 86.6818C245.357 86.6818 241.838 90.2006 241.838 94.5413C241.838 98.882 245.357 102.401 249.698 102.401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M231.457 105.273L232.883 103.983C234.113 102.87 235.919 102.774 237.257 103.67L235.682 105.245L238.117 109.452L239.431 108.139L239.809 109.724L235.969 113.525C235.542 113.947 234.876 114.008 234.38 113.67L229.876 110.601C229.296 110.206 229.115 109.434 229.459 108.822L231.457 105.273Z",
    fill: "#F6A68D"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M247.062 118.454L248.946 121.037",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M255.612 122.228C255.582 122.092 255.545 121.958 255.502 121.826C254.382 118.418 250.105 115.678 247.777 117.216L250.366 112.605C251.435 110.835 252.957 109.383 254.773 108.396L257.334 107.005L260.9 110.331L261.573 118.515L255.612 122.228Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M255.612 122.228C255.82 123.18 255.694 124.218 255.13 125.006C254.663 125.658 253.871 126.083 253.083 126.102L255.612 122.228Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M236.925 112.791L239.809 109.724L239.431 108.139",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M255.829 117.635L257.471 129.653",
    stroke: "#1F97FC",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_15439",
    x1: 274.992,
    y1: 237.217,
    x2: 160.039,
    y2: 237.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DACFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE7EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinInterest);
export default __webpack_public_path__ + "static/media/coinInterest.18b7cb9a37d2e93888cd89042404810a.svg";
export { ForwardRef as ReactComponent };